import { quickFeatures } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function FeatureGrid() {
  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="核心内容速览"
          title="四件事，决定你能不能顺利追剧"
          description="从把应用装到手机，到把剧集缓存好、离线也能看，整条链路其实就围绕这四件事展开。下面每一块都有更详细的步骤说明。"
        />

        <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:mt-12 md:gap-5">
          {quickFeatures.map((feature) => (
            <article
              key={feature.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 md:h-12 md:w-12">
                  <i className={`${feature.icon} text-xl text-primary-600 md:text-2xl`}></i>
                </span>
                <span className="rounded-full bg-accent-100 px-2.5 py-1 text-xs font-semibold text-accent-800">
                  {feature.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 md:text-xl">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{feature.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}